import { render, staticRenderFns } from "./UserPasswordForm.vue?vue&type=template&id=7b6caf68&scoped=true&"
import script from "./UserPasswordForm.vue?vue&type=script&lang=js&"
export * from "./UserPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./UserPasswordForm.vue?vue&type=style&index=0&id=7b6caf68&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6caf68",
  null
  
)

export default component.exports